<div class="container-fluid">
  <div class="user-page">
    <div class="row" style="margin-top: 15px;">
      <div class="col-md-1 d-block d-sm-block d-md-none mobile-icon">
        <div class="btn-show">
          <mat-icon (click)="openModal({})"> <i class="material-icons">
              add_circle
            </i></mat-icon>
        </div>
      </div>
      <div class="col-md-3">
        <form action="" class="form-fields show-search">
          <div class="form-group">
            <mat-form-field>
              <input matInput id="filter-text-box" placeholder="Search" (keyup)="onFilterTextBoxChanged($event)">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div class="col-md-9 d-none d-sm-none d-md-block tablet-icon">
        <div class="btn-show">
          <button mat-icon-button color="primary" (click)="openModal({})">
            <i class="material-icons">
              add_circle
            </i>
          </button>

        </div>
      </div>
    </div>
  </div>

  <div class="all-show-grid">
    <ag-grid-angular class="ag-theme-material" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
      [columnDefs]="columnDefs" [rowData]="financeList" (gridReady)="onGridReady($event)"  #grid>
    </ag-grid-angular>
  </div>
